import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/styles/main.sass' 
import 'vuetify/dist/vuetify.min.css'

Vue.use( Vuetify );

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#4ebdef',
        secondary: '#3953a3',
        accent: '#a8d6e7',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
})

